import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Card,
  Button,
  Tag,
  Input,
  Spin,
  Progress,
  Modal, Alert,
   Form,
  Select,
  DatePicker,
  Upload,
  message
} from "antd";
import {
  PlusOutlined,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  UploadOutlined 
} from "@ant-design/icons";
import axios from "axios";
import { ToastContainer,toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import dayjs from "dayjs";

function CoursesStudent() {
  const [courses, setCourses] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [filterStatus, setFilterStatus] = useState("ALL");

  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
const [selectedCourse, setSelectedCourse] = useState(null);
const [confirmText, setConfirmText] = useState("");
const [deleting, setDeleting] = useState(false);

const [createModalOpen, setCreateModalOpen] = useState(false);
const [creating, setCreating] = useState(false);
const [file, setFile] = useState(null);

const [previewUrl, setPreviewUrl] = useState(null);

const [form] = Form.useForm();

  const navigate = useNavigate();

  // Auth info
  const token = localStorage.getItem("token");
  const fullName = localStorage.getItem("fullName");
  const role = (localStorage.getItem("role") || "").toUpperCase();

  useEffect(() => {
    if (!token || !fullName || !role) {
      navigate("/user/sign_in");
    }
  }, [token, fullName, role, navigate]);


  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
    try {
      setLoading(true);

      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/course-access/courses-from-course-access`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (res.data.success) {
        setCourses(res.data.data);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FULL MONTH NAME
  const formatDate = (date) =>
    new Date(date).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    });

  const getStatus = (course) => {
    const today = new Date();
    const start = new Date(course.BatchStartDate);
    const end = new Date(course.BatchEndDate);

    if (start > today) return "UPCOMING";
    if (end < today) return "COMPLETED";
    return "ACTIVE";
  };

  const filteredCourses = courses
    .filter((course) =>
      course.CourseName?.toLowerCase().includes(
        searchText.toLowerCase()
      )
    )
    .filter((course) => {
      if (filterStatus === "ALL") return true;
      return getStatus(course) === filterStatus;
    });

    const handleDeleteCourse = async () => {
  try {
    setDeleting(true);

    await axios.delete(
      `${process.env.REACT_APP_API_URL}/course/delete-course`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        data: {
          CourseName: selectedCourse.CourseName,
          BatchName: selectedCourse.BatchName,
          BatchType: selectedCourse.BatchType,
        },
      }
    );

    setDeleteModalOpen(false);
    setConfirmText("");
    setSelectedCourse(null);

    fetchCourses();
  } catch (err) {
    console.error(err);
  } finally {
    setDeleting(false);
  }
};

const handleImageUpload = ({ file }) => {
  setFile(file);
};

const handleCreateCourse = async (values) => {
  try {
    setCreating(true);

    const formData = new FormData();

    formData.append("CourseName", values.CourseName);
    formData.append("BatchName", values.BatchName);
    formData.append("BatchType", values.BatchType);
    formData.append("ProgramName", values.ProgramName);
    formData.append("CourseType", values.CourseType);
    formData.append("CourseTiming", values.CourseTiming);

    formData.append(
      "BatchStartDate",
      dayjs(values.BatchStartDate).format("YYYY-MM-DD")
    );

    formData.append(
      "BatchEndDate",
      dayjs(values.BatchEndDate).format("YYYY-MM-DD")
    );

    if (file) {
      formData.append("image", file);
    }

   const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/course/create-course`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data"
        }
      }
    );

   if(res.data.success) {
     toast.success(res.data.message||"Course created successfully");
     
    form.resetFields();
    setFile(null);
    setCreateModalOpen(false);

    fetchCourses();
   }


  } catch (error) {
    // console.error(error);
    toast.error("Failed to create course");
  } finally {
    setCreating(false);
  }
};

  return (
    <div className="min-h-screen p-8 bg-[#0f172a] text-white">

       <ToastContainer
                          position="bottom-left"
                          autoClose={5000}
                          hideProgressBar={true}
                          newestOnTop={false}
                          closeOnClick
                          rtl={false}
                          pauseOnFocusLoss
                          draggable
                          pauseOnHover
                          theme="dark"
                          className="!mb-6 !ml-4"
                          toastClassName="!inline-flex !items-center !whitespace-nowrap !bg-black !text-white !px-4 !py-2 !rounded-lg !w-auto !min-w-0 !shadow-lg"
                        />

      {/* HEADER */}
      <div className="flex items-center justify-between mb-8">
        <h2 className="text-3xl font-bold">
          Courses Management
        </h2>

       {/* <Button
  type="primary"
  icon={<PlusOutlined />}
  className="bg-green-600 !border-none font-semibold text-white text-lg py-5"
  onClick={() => setCreateModalOpen(true)}
>
  Create Course
</Button> */}
      </div>

      {/* SEARCH + FILTER */}
      <div className="flex flex-wrap gap-4 mb-8">
        <Input
          prefix={<SearchOutlined />}
          placeholder="Search course..."
          value={searchText}
          onChange={(e) => setSearchText(e.target.value)}
          allowClear
          className="max-w-sm"
        />

        <div className="flex gap-3">
          {["ALL", "ACTIVE", "UPCOMING", "COMPLETED"].map(
            (status) => (
              <Button
                key={status}
                type={
                  filterStatus === status
                    ? "primary"
                    : "default"
                }
                onClick={() => setFilterStatus(status)}
              >
                {status}
              </Button>
            )
          )}
        </div>
      </div>

      {/* GRID */}
      {loading ? (
        <div className="flex justify-center py-20">
          <Spin size="large" />
        </div>
      ) : (
        <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">

          {filteredCourses.map((course) => {
            const status = getStatus(course);
            const progress = course.CourseStatus || 0;

            return (
             <Card
  key={course.id}
  hoverable
  className={`
    relative overflow-hidden
    bg-[#1e293b]
    rounded-2xl
    text-white
    border
    transition-all
    duration-300
    hover:scale-[1.02]
    ${
      status === "ACTIVE"
        ? "border-cyan-400 hover:shadow-[0_0_30px_rgba(34,211,238,0.7)]"
        : status === "UPCOMING"
        ? "border-blue-400 hover:shadow-[0_0_30px_rgba(59,130,246,0.6)]"
        : "border-gray-700 hover:shadow-[0_0_25px_rgba(239,68,68,0.4)]"
    }
  `}
  cover={
    <img
      src={
        course.CourseImageUrl ||
        "https://via.placeholder.com/400x250"
      }
      alt={course.CourseName}
      className="object-fill w-full h-60"
    />
  }
>

                {/* STATUS BADGE */}
                <div className="flex items-center justify-between mb-3">
                  <Tag
                    color={
                      status === "ACTIVE"
                        ? "green"
                        : status === "UPCOMING"
                        ? "blue"
                        : "red"
                    }
                  >
                    {status}
                  </Tag>

                  <Tag className="font-semibold text-white bg-black" >
                    {course.CourseType}
                  </Tag>
                </div>

                <h3 className="mb-1 text-lg font-bold">
                  {course.CourseName}
                </h3>

                <p className="mb-3 font-semibold text-gray-400">
                  {course.ProgramName}
                </p>

                {/* ✅ BATCH INFO WITH EMOJIS */}
                <div className="mb-4 space-y-2 text-sm font-semibold text-white">

                  <div>
                    📅 {course.BatchName} - {course.BatchType}
                  </div>

                  <div>
                    🕒 {course.CourseTiming}
                  </div>

                  <div>
                    📅 {formatDate(course.BatchStartDate)} →{" "}
                    {formatDate(course.BatchEndDate)}
                  </div>

                </div>

                {/* PROGRESS BAR */}
                <div className="mb-4">
                  <Progress
                    percent={progress}
                    strokeWidth={12}
                    strokeColor={{
                      "0%": "#06b6d4",
                      "50%": "#3b82f6",
                      "100%": "#a855f7",
                    }}
                    trailColor="#1f2937"
                    format={(percent) => (
                      <span style={{ color: "#ffffff", fontWeight: 700 }}>
                        {percent}%
                      </span>
                    )}
                  />
                </div>

                {/* ACTIONS */}
<div className="flex gap-3 mt-4">

  {/* VIEW COURSE */}
  <Button
  type="primary"
  className="flex-1 !bg-blue-600 !border-none"
  onClick={(e) => {
    e.stopPropagation();
    navigate(
      `/academy/mentee-dashboard/${course.id}/active/course-details`
    );
  }}
>
  View Details
</Button>

  {/* EDIT */}
  {/* <Button
    icon={<EditOutlined />}
    className="flex-1"
    onClick={(e) => {
      e.stopPropagation();
      navigate(
        `/academy/operations/courses/${course.CourseName}/edit/${course.id}`
      );
    }}
  >
    Edit
  </Button> */}

  {/* DELETE */}
  {/* <Button
  icon={<DeleteOutlined />}
  danger
  onClick={(e) => {
    e.stopPropagation();
    setSelectedCourse(course);
    setDeleteModalOpen(true);
  }}
>
  Delete
</Button> */}

</div>

              </Card>
            );
          })}

        </div>
      )}

      <Modal
  open={deleteModalOpen}
  footer={null}
  onCancel={() => {
    setDeleteModalOpen(false);
    setConfirmText("");
  }}
  centered
  width={520}
>
  <div className="space-y-5">

    {/* HEADER */}
    <div className="pb-3 border-b">
      <h2 className="text-xl font-bold text-red-600">
        Delete Course
      </h2>

      <p className="mt-1 text-sm text-gray-500">
        This action cannot be undone.
      </p>
    </div>

    {/* WARNING BOX */}
    <div className="p-4 border border-red-300 rounded-lg bg-red-50">

      <h3 className="mb-3 font-semibold text-red-700">
        Deleting this course will permanently remove:
      </h3>

      <ul className="space-y-2 text-sm text-red-700 list-disc list-inside">

        <li>
          The entire course <b>{selectedCourse?.CourseName}</b>
        </li>

        <li>
          All modules, sessions, recordings and course content
        </li>

        <li>
          Course access for all enrolled students
        </li>

        <li>
          Related mock interviews associated with this course
        </li>

        <li>
          Batch information and progress tracking
        </li>

      </ul>

    </div>

    {/* CONFIRM TEXT */}
    <div>
      <p className="mb-2 text-sm font-medium">
        Type <span className="font-bold text-red-600">DELETE</span> to confirm
      </p>

      <Input
        placeholder="Type DELETE to confirm"
        value={confirmText}
        onChange={(e) => setConfirmText(e.target.value)}
      />
    </div>

    {/* ACTION BUTTONS */}
    <div className="flex justify-end gap-3 pt-2">

      <Button
        onClick={() => {
          setDeleteModalOpen(false);
          setConfirmText("");
        }}
      >
        Cancel
      </Button>

      {confirmText === "DELETE" && (
        <Button
          danger
          loading={deleting}
          className="!bg-red-600 !border-red-600 text-white font-semibold"
          onClick={handleDeleteCourse}
        >
          Delete Course
        </Button>
      )}

    </div>

  </div>
</Modal>

<Modal
  open={createModalOpen}
  footer={null}
  onCancel={() => setCreateModalOpen(false)}
  centered
  width={850}
>

  <div className="space-y-6">

    {/* HEADER */}
    <div className="pb-4 border-b">

      <h2 className="text-2xl font-bold text-green-600">
        Create New Course
      </h2>

      <p className="text-sm text-gray-500">
        Create a new course batch for your academy
      </p>

    </div>

   <Form
  form={form}
  layout="vertical"
  onFinish={handleCreateCourse}
>

  <div className="grid grid-cols-2 gap-4">

    {/* COURSE NAME */}
    <Form.Item
      label="Course Name"
      name="CourseName"
      rules={[{ required: true }]}
      className="col-span-1"
    >
      <Input placeholder="Junior Penetration Tester" />
    </Form.Item>

    {/* PROGRAM NAME */}
    <Form.Item
      label="Program Name"
      name="ProgramName"
      rules={[{ required: true }]}
      className="col-span-1"
    >
      <Input placeholder="eg,VAPT or SOC" />
    </Form.Item>

    {/* BATCH NAME */}
    <Form.Item
      label="Batch Name"
      name="BatchName"
      rules={[{ required: true }]}
    >
      <Input placeholder="eg,MARCH2026" />
    </Form.Item>

    {/* BATCH TYPE */}
    <Form.Item
      label="Batch Type"
      name="BatchType"
      rules={[{ required: true }]}
    >
      <Select
        options={[
          { value: "MORNING", label: "MORNING" },
          { value: "EVENING", label: "EVENING" }
        ]}
      />
    </Form.Item>

    {/* COURSE TYPE */}
    <Form.Item
      label="Course Type"
      name="CourseType"
      rules={[{ required: true }]}
    >
      <Select
        options={[
          { value: "PUBLIC", label: "PUBLIC" },
          { value: "PRIVATE", label: "PRIVATE" }
        ]}
      />
    </Form.Item>

    {/* COURSE TIMING */}
    <Form.Item
      label="Course Timing"
      name="CourseTiming"
      rules={[{ required: true }]}
    >
      <Input placeholder="7:00 PM - 9:00 PM" />
    </Form.Item>

    {/* START DATE */}
    <Form.Item
      label="Batch Start Date"
      name="BatchStartDate"
      rules={[{ required: true }]}
    >
      <DatePicker className="w-full" />
    </Form.Item>

    {/* END DATE */}
    <Form.Item
      label="Batch End Date"
      name="BatchEndDate"
      rules={[{ required: true }]}
    >
      <DatePicker className="w-full" />
    </Form.Item>

  </div>

  {/* IMAGE UPLOAD (FULL WIDTH) */}
  <div className="mt-4">

    <Form.Item label="Course Thumbnail">

      <Upload
        accept="image/*"
        maxCount={1}
        showUploadList={false}
        beforeUpload={(file) => {

          const allowedTypes = [
            "image/jpeg",
            "image/png",
            "image/webp"
          ];

          if (!allowedTypes.includes(file.type)) {
            message.error("Only JPG, PNG or WEBP images allowed");
            return Upload.LIST_IGNORE;
          }

          setFile(file);

          const preview = URL.createObjectURL(file);
          setPreviewUrl(preview);

          return false;
        }}
      >

        <Button
          icon={<UploadOutlined />}
          className="m-2 font-semibold text-white bg-blue-600"
        >
          Select Image
        </Button>

      </Upload>

      {previewUrl && (
        <div className="mt-4">

          <p className="mb-2 text-sm font-bold text-gray-500">
            Thumbnail Preview
          </p>

          <img
            src={previewUrl}
            alt="Preview"
            className="object-cover w-full h-48 border rounded-lg"
          />

        </div>
      )}

    </Form.Item>

  </div>

  {/* ACTION BUTTONS */}
  <div className="flex justify-end gap-3 pt-4">

    <Button
      onClick={() => setCreateModalOpen(false)}
    >
      Cancel
    </Button>

    <Button
      type="primary"
      htmlType="submit"
      loading={creating}
      className="!bg-green-600 !border-none font-semibold"
    >
      Create Course
    </Button>

  </div>

</Form>

  </div>

</Modal>
    </div>
  );
}

export default CoursesStudent;